/* =====================================================================
   VK-Q5 · secciones de la ficha (paquete «secciones», 04/10/2026)
   1. Enlaces a #vk-faq-*: abren la pregunta antes del salto (también al cargar con ese hash).
   2. Pestañas del montaje (role=tab, aria-selected, flechas, Inicio y Fin).
   3. Vídeos de vk-brake y vk-modes: se reproducen al entrar en pantalla y se pausan al salir.
      Nunca con prefers-reduced-motion (el vídeo de modos tiene destellos): se queda el póster.
   Cada sección carga este archivo; la guarda evita que se inicie más de una vez.
   ===================================================================== */
(function () {
  'use strict';
  if (window.vkSections) return;
  window.vkSections = true;

  var reduceMotion = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)')
    : { matches: false };

  /* ---------- 1. Preguntas frecuentes con ancla ---------- */
  function detailsFor(id) {
    var el = id ? document.getElementById(id) : null;
    if (!el) return null;
    if (el.tagName === 'DETAILS') return el;
    return el.closest('details') || el.querySelector('details');
  }

  function openFromHash(hash, scroll) {
    if (!hash || hash.indexOf('#vk-faq-') !== 0) return;
    var id = hash.slice(1);
    try { id = decodeURIComponent(id); } catch (e) { /* hash sin codificar */ }
    var details = detailsFor(id);
    if (!details) return;
    details.open = true;
    if (scroll) {
      var target = document.getElementById(id) || details;
      target.scrollIntoView({ block: 'start' });
    }
  }

  // Fase de captura: la pregunta se abre antes de que el navegador haga el salto.
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[href^="#vk-faq-"]');
    if (link) openFromHash(link.getAttribute('href'), false);
  }, true);

  window.addEventListener('hashchange', function () {
    openFromHash(window.location.hash, false);
  });

  if (window.location.hash) openFromHash(window.location.hash, true);

  /* ---------- 2. Pestañas del montaje ---------- */
  function selectTab(tab, focus) {
    var list = tab.closest('[role="tablist"]');
    if (!list) return;
    var tabs = list.querySelectorAll('[role="tab"]');
    for (var i = 0; i < tabs.length; i++) {
      var on = tabs[i] === tab;
      tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
      tabs[i].tabIndex = on ? 0 : -1;
      var panel = document.getElementById(tabs[i].getAttribute('aria-controls'));
      if (panel) panel.hidden = !on;
    }
    if (focus) tab.focus();
  }

  document.addEventListener('click', function (event) {
    var tab = event.target.closest && event.target.closest('.vk-seg [role="tab"]');
    if (tab) selectTab(tab, false);
  });

  document.addEventListener('keydown', function (event) {
    var tab = event.target.closest && event.target.closest('.vk-seg [role="tab"]');
    if (!tab) return;
    var tabs = Array.prototype.slice.call(tab.closest('[role="tablist"]').querySelectorAll('[role="tab"]'));
    var index = tabs.indexOf(tab);
    var next = null;
    switch (event.key) {
      case 'ArrowRight': next = tabs[(index + 1) % tabs.length]; break;
      case 'ArrowLeft': next = tabs[(index - 1 + tabs.length) % tabs.length]; break;
      case 'Home': next = tabs[0]; break;
      case 'End': next = tabs[tabs.length - 1]; break;
      default: return;
    }
    event.preventDefault();
    selectTab(next, true);
  });

  /* ---------- 3. Vídeos perezosos ---------- */
  function playVideo(video) {
    if (reduceMotion.matches) return;
    video.muted = true;
    var promise = video.play();
    if (promise && typeof promise.catch === 'function') promise.catch(function () {});
  }

  var observer = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) playVideo(entry.target);
          else if (!entry.target.paused) entry.target.pause();
        });
      }, { rootMargin: '200px 0px' })
    : null;

  function initVideos(root) {
    if (!observer) return;
    var videos = (root || document).querySelectorAll('video[data-vk-autoplay]');
    for (var i = 0; i < videos.length; i++) {
      if (videos[i].dataset.vkBound) continue;
      videos[i].dataset.vkBound = '1';
      observer.observe(videos[i]);
    }
  }

  function onReduceChange() {
    if (!reduceMotion.matches) return;
    var videos = document.querySelectorAll('video[data-vk-autoplay]');
    for (var i = 0; i < videos.length; i++) videos[i].pause();
  }
  if (reduceMotion.addEventListener) reduceMotion.addEventListener('change', onReduceChange);
  else if (reduceMotion.addListener) reduceMotion.addListener(onReduceChange);

  initVideos(document);

  // Editor de temas: secciones que se vuelven a pintar
  document.addEventListener('shopify:section:load', function (event) {
    initVideos(event.target);
  });
})();
